import React from 'react';
import { useBreakpoints } from '../../../../../hooks/useBreakpoints';
import { classes, st } from './Section.st.css';

export const Section: React.FC = ({ children }) => {
  const { isNarrow } = useBreakpoints();
  return <div className={st(classes.root, { narrow: isNarrow })}>{children}</div>;
};
